import { components, isEmpty } from '@/utils'

import { basic, core } from '@/components/g/checkbox/mixins'

import render from './render'

export default {
  name: components.checkbox,

  mixins: [ core, basic ],

  computed: {
    $_class() {
      return {
        [`${components.checkbox}`]: true,
        [`${components.checkbox}--checked`]: this.checked,
        [`${components.checkbox}--disabled`]: this.disabled,
        [`${components.checkbox}--unknown`]: isEmpty(this.proxy),
        [`${components.checkbox}--labeled`]: !!this.label,
        [`${components.checkbox}--outline`]: this.outline
      }
    }
  },

  render
}

